import React from 'react';

export const HeaderBar = () => (
  <div className={'flex flex-row w-full gap-1 items-center px-2 font-semibold bg-slate-100'}>
    <div className={'basis-44'}>Created At</div>
    <div className={'basis-32'}>File Number</div>
    <div className={'basis-52'}>Borrower Name</div>
    <div className={'grow'}>Property Address</div>
    <div className={'basis-40'}>Account</div>
    <div className={'basis-32'}>Amount</div>
    <div className={'basis-36'}>&nbsp;</div>
  </div>
);
